export const getRows = (state) => {
  return state?.settings?.exchangeRates || [];
};

export const exchangeRateChoicesSelector = (state) => {
  const choices = {};

  const exchangeRates = getRows(state);
  exchangeRates.forEach((exchangeRate) => {
    choices[exchangeRate.name] = exchangeRate.id;
  });

  return choices;
};

export default getRows;
